import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const fetchPrestadores = async (idDep, idMuni='', tipo='', ese='', active = false) => {
  
  if (!idDep && active) return [];
  try {
    const res = await request(API_ROUTES.getPrestadores(idDep, idMuni, tipo, ese, active ), { method: "GET" });
    if (!res.ok) throw new Error("Error en la petición de municipios");
    const rs = await res.json();
    const json = rs.data;
    return json.GetPrestadores || [];
  } catch (err) {
    console.error("Error cargando prestadores:", err);
    return [];
  }
};
